import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card, Alert } from 'react-bootstrap';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const contactInfo = [
    {
      icon: 'fas fa-map-marker-alt',
      title: 'მისამართი',
      content: 'რუსთავის 15, თბილისი, საქართველო',
      link: 'https://maps.google.com/?q=რუსთავის+15,+თბილისი'
    },
    {
      icon: 'fas fa-phone',
      title: 'ტელეფონი',
      content: '+995 555 123 456',
      link: 'tel:+995555123456'
    },
    {
      icon: 'fas fa-envelope',
      title: 'ელ-ფოსტა',
      content: 'info@lekvi.ge',
      link: 'mailto:info@lekvi.ge'
    },
    {
      icon: 'fas fa-clock',
      title: 'სამუშაო საათები',
      content: 'ორშაბათი - პარასკევი: 11:00 - 23:00\nშაბათი - კვირა: 12:00 - 00:00'
    }
  ];

  const socialMedia = [
    { name: 'Facebook', icon: 'fab fa-facebook', link: 'https://facebook.com', color: 'text-primary' },
    { name: 'Instagram', icon: 'fab fa-instagram', link: 'https://instagram.com', color: 'text-danger' },
    { name: 'Twitter', icon: 'fab fa-twitter', link: 'https://twitter.com', color: 'text-info' },
    { name: 'YouTube', icon: 'fab fa-youtube', link: 'https://youtube.com', color: 'text-danger' }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate form
    if (!formData.name || !formData.email || !formData.subject || !formData.message) {
      setShowError(true);
      setShowSuccess(false);
      return;
    }

    // Simulate form submission
    console.log('Contact form submitted:', formData);
    
    // Show success message
    setShowSuccess(true);
    setShowError(false);
    
    // Reset form
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="py-5">
      <Container>
        {/* Header */}
        <Row className="text-center mb-5">
          <Col>
            <h1 className="display-4 fw-bold text-dark mb-3">კონტაქტი</h1>
            <p className="lead text-muted">
              დაგვიკავშირდით ნებისმიერი კითხვისთვის ან დაჯავშნისთვის
            </p>
          </Col>
        </Row>

        <Row>
          {/* Contact Form */}
          <Col lg={8} className="mb-4">
            <Card className="shadow-sm">
              <Card.Body className="p-4">
                <h3 className="text-warning mb-4">
                  <i className="fas fa-envelope me-2"></i>
                  დაგვიკავშირდით
                </h3>

                {showSuccess && (
                  <Alert variant="success" onClose={() => setShowSuccess(false)} dismissible>
                    <i className="fas fa-check-circle me-2"></i>
                    თქვენი შეტყობინება წარმატებით გაიგზავნა! ჩვენ მალე დაგიკავშირდებით.
                  </Alert>
                )}

                {showError && (
                  <Alert variant="danger" onClose={() => setShowError(false)} dismissible>
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    გთხოვთ შეავსოთ ყველა სავალდებულო ველი.
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          <i className="fas fa-user me-2"></i>
                          სახელი და გვარი *
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          placeholder="შეიყვანეთ თქვენი სახელი"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          <i className="fas fa-envelope me-2"></i>
                          ელ-ფოსტა *
                        </Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          placeholder="შეიყვანეთ ელ-ფოსტა"
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">
                      <i className="fas fa-tag me-2"></i>
                      თემა *
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      placeholder="შეიყვანეთ თემა"
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label className="fw-bold">
                      <i className="fas fa-comment me-2"></i>
                      შეტყობინება *
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      placeholder="შეიყვანეთ თქვენი შეტყობინება"
                      required
                    />
                  </Form.Group>

                  <Button 
                    type="submit" 
                    variant="warning" 
                    size="lg" 
                    className="w-100 fw-bold"
                  >
                    <i className="fas fa-paper-plane me-2"></i>
                    შეტყობინების გაგზავნა
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>

          {/* Contact Information */}
          <Col lg={4}>
            <Card className="shadow-sm h-100">
              <Card.Body className="p-4">
                <h4 className="text-warning mb-4">
                  <i className="fas fa-info-circle me-2"></i>
                  კონტაქტის ინფორმაცია
                </h4>
                
                {contactInfo.map((info, index) => (
                  <div key={index} className="mb-4">
                    <h6 className="fw-bold">
                      <i className={`${info.icon} me-2 text-warning`}></i>
                      {info.title}
                    </h6>
                    {info.link ? (
                      <a 
                        href={info.link} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-decoration-none"
                      >
                        <p className="text-muted mb-0">{info.content}</p>
                      </a>
                    ) : (
                      <p className="text-muted mb-0" style={{ whiteSpace: 'pre-line' }}>
                        {info.content}
                      </p>
                    )}
                  </div>
                ))}

                <hr className="my-4" />

                <div className="mb-4">
                  <h6 className="fw-bold mb-3">
                    <i className="fas fa-share-alt me-2 text-warning"></i>
                    სოციალური ქსელები
                  </h6>
                  <div className="d-flex gap-3">
                    {socialMedia.map((social, index) => (
                      <a
                        key={index}
                        href={social.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`${social.color} fs-4 text-decoration-none`}
                        title={social.name}
                      >
                        <i className={social.icon}></i>
                      </a>
                    ))}
                  </div>
                </div>

                <div className="text-center">
                  <Button variant="outline-warning" className="w-100 fw-bold">
                    <i className="fas fa-download me-2"></i>
                    მენიუს ჩამოტვირთვა
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Map Section */}
        <Row className="mt-5">
          <Col>
            <Card className="shadow-sm">
              <Card.Body className="p-0">
                <div className="position-relative">
                  <div 
                    className="bg-light d-flex align-items-center justify-content-center"
                    style={{ height: '400px' }}
                  >
                    <div className="text-center">
                      <i className="fas fa-map-marked-alt fa-4x text-muted mb-3"></i>
                      <h5 className="text-muted">რუსთავის 15, თბილისი</h5>
                      <p className="text-muted">საქართველო</p>
                      <Button 
                        variant="warning" 
                        href="https://maps.google.com/?q=რუსთავის+15,+თბილისი"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fas fa-external-link-alt me-2"></i>
                        ნახეთ რუკაზე
                      </Button>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* FAQ Section */}
        <Row className="mt-5">
          <Col>
            <Card className="shadow-sm">
              <Card.Body className="p-4">
                <h3 className="text-warning mb-4">
                  <i className="fas fa-question-circle me-2"></i>
                  ხშირად დასმული კითხვები
                </h3>
                
                <Row>
                  <Col md={6}>
                    <div className="mb-4">
                      <h6 className="fw-bold">როგორ შემიძლია დაჯავშნა გავაკეთო?</h6>
                      <p className="text-muted">
                        დაჯავშნა შეგიძლიათ ონლაინ ჩვენს ვებსაიტზე, ტელეფონით +995 555 123 456, 
                        ან პირადად რესტორანში.
                      </p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-4">
                      <h6 className="fw-bold">რა არის სამუშაო საათები?</h6>
                      <p className="text-muted">
                        ორშაბათი - პარასკევი: 11:00 - 23:00<br />
                        შაბათი - კვირა: 12:00 - 00:00
                      </p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-4">
                      <h6 className="fw-bold">არის თუ არა უფასო Wi-Fi?</h6>
                      <p className="text-muted">
                        კი, ჩვენს რესტორანში უფასო Wi-Fi ხელმისაწვდომია ყველა სტუმრისთვის.
                      </p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-4">
                      <h6 className="fw-bold">შეგვიძლია თუ არა ქორწილის ორგანიზება?</h6>
                      <p className="text-muted">
                        კი, ჩვენ ვორგანიზებთ ქორწილებს და სხვა ღონისძიებებს. 
                        დაგვიკავშირდით დეტალებისთვის.
                      </p>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contact;
